import {request} from "./request";
import store from '../store/index'

// 获取账号列表
export function getAdminList(pagesize) {
    return request({
        url: '/hkt_admin/admin/get_admin_list',
        headers: {
            'token': store.state.token
        },
        params: {
            pagesize,
        }
    })
}
// 添加账号
export function addAdmin(phone, name, state, password, power_id) {
    return request({
        url: '/hkt_admin/admin/add_admin',
        headers: {
            'token': store.state.token
        },
        params: {
            phone,
            name,
            state,
            password,
            power_id
        }
    })
}
// 编辑账号
export function editAdmin(admin_id, name, power_id, state) {
    return request({
        url: '/hkt_admin/admin/edit_admin',
        headers: {
            'token': store.state.token
        },
        params: {
            admin_id,
            name,
            power_id,
            state,

        }
    })
}
// 编辑账号
export function editState(admin_id, state) {
    return request({
        url: '/hkt_admin/admin/edit_admin',
        headers: {
            'token': store.state.token
        },
        params: {
            admin_id,
            state,
        }
    })
}